import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallChip } from '../../../components/chips/SmallChip';

type Props = {
  count: number;
};

export const TimelineChip: FC<Props> = ({ count }) => {
  return (
    <SmallChip color="warning">
      <FormattedMessage id="TimelineChip" values={{ count }} />
    </SmallChip>
  );
};
